// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Open Sans', sans-serif;
}

html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
}

#root {
    height: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: 'Montserrat', sans-serif;
}

p,
span,
a {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
}

.ms-ft-16 {
    font-size: 16px;
    line-height: 22px;
}

.ms-ft-30 {
    font-size: 30px;
    line-height: 37px;
}

.ms-ft-12 {
    font-size: 12px;
    line-height: 16px;
}

.ms-ft-20 {
    font-size: 20px;
    line-height: 30px;
}

.ms-ft-15 {
    font-size: 15px;
    line-height: 20px;
}

.ms-ft-18 {
    font-size: 18px;
    line-height: 24px;
}

.ms-ft-22 {
    font-size: 22px;
    line-height: 29px;
}

.ms-ft-24 {
    font-size: 24px;
    line-height: 30px;
}

.ms-ft-40 {
    font-size: 40px;
    line-height: 48px;
}

.ms-ft-35 {
    font-size: 35px;
    line-height: 42.67px;
}

.ms-fw-600 {
    font-weight: 600;
}

.ms-fw-400 {
    font-weight: 400;
}

.ms-fw-700 {
    font-weight: 700;
}

.ms-fw-800 {
    font-weight: 800;
}


.ms-ft-primary {
    color: #00863F;
}

.ms-ft-black {
    color: #000;
}

.ms-ft-medblack {
    color: #212121;
}

.ms-ft-fadedblack {
    color: #4c4c4c
}

.ms-ft-grey {
    color: #B5B5B5;
}

.ms-ft-darkgrey {
    color: #54595F;
}

.ms-ft-mediumgrey {
    color: #777;
}

.ms-ft-lightgrey {
    color: #A3A3A3;
}

.mt-30 {
    margin-top: 30px;
}

.mt-50 {
    margin-top: 50px;
}

.mt-45 {
    margin-top: 45px;
}

.mt-40 {
    margin-top: 40px;
}

.mt-100 {
    margin-top: 100px;
}

.mt-20 {
    margin-top: 20px;
}

.pt-50 {
    padding-top: 50px;
}

.pl-20 {
    padding-left: 20px;
}

.btn-primary {
    background-color: #00863F;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:target {
    background-color: #00863F;
}

.btn-secondary {
    background-color: #007BB6;
    color: #fff;
}

.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary:target {
    background-color: #007BB6;
}

.btn-info {
    background-color: #666666;
    color: #fff;
}

.btn-info:hover,
.btn-info:focus,
.btn-info:target {
    background-color: #666666;
}

.btn-light {
    background-color: #ECECEE;
    color: #BEBDBF;
}

.btn-light:hover,
.btn-light:focus,
.btn-light:target {
    background-color: #ECECEE;
}

.btn {
    font-family: 'Montserrat', sans-serif;
    border-radius: 0px;
    border: none;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
}

.ms-lh-20 {
    line-height: 20px;
}

.badge.bg-primary {
    background-color: #00863F24 !important;
    font-family: Open Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.25px;
    text-align: left;
    color: #00863F;
    border-radius: 20px;
}

.full-height {
    height: 100vh;
}

.form-check-input:checked {
    background-color: #00863F;
    border-color: #00863F;
}

.light-text {
    color: #b3b3b3;
}

.dark-text-med {
    color: #424242;
}

.fixed-height-30 {
    min-height: 30px;
}

.light-text-med {
    color: #808080;
}

.navbar {
    float: unset !important;
}

.btn.disabled,
.btn:disabled {
    background-color: #808080;
    color: #000;
    pointer-events: none;
}

::-ms-reveal {
    display: none;
}

.error-message {
    position: absolute;
    bottom: -20px;
    color: red;
    font-size: 12px;
    margin-bottom: 0;
}

.text-danger {
    color: #e25425 !important;
}

.spinner-border{
    color: #00863F;
}

.spinner-border-popup{
    color: #eaf1ed;
}

.section-overlay {
    z-index: 9999;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0.8;
}

.section-loader.loading {
    position: fixed;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 40px;
    height: 40px;
    z-index: 10000;
    background: transparent;
  }
`, "",{"version":3,"sources":["webpack://./src/assets/css/app.css"],"names":[],"mappings":"AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;IAMI,qCAAqC;AACzC;;AAEA;;;IAGI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;;;IAII,qDAAqD;AACzD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,cAAc;IACd,uBAAuB;EACzB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');\n\nbody {\n    font-family: 'Open Sans', sans-serif;\n}\n\nhtml,\nbody {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n}\n\n#root {\n    height: 100%;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: 'Montserrat', sans-serif;\n}\n\np,\nspan,\na {\n    font-family: 'Open Sans', sans-serif;\n    font-weight: 400;\n}\n\n.ms-ft-16 {\n    font-size: 16px;\n    line-height: 22px;\n}\n\n.ms-ft-30 {\n    font-size: 30px;\n    line-height: 37px;\n}\n\n.ms-ft-12 {\n    font-size: 12px;\n    line-height: 16px;\n}\n\n.ms-ft-20 {\n    font-size: 20px;\n    line-height: 30px;\n}\n\n.ms-ft-15 {\n    font-size: 15px;\n    line-height: 20px;\n}\n\n.ms-ft-18 {\n    font-size: 18px;\n    line-height: 24px;\n}\n\n.ms-ft-22 {\n    font-size: 22px;\n    line-height: 29px;\n}\n\n.ms-ft-24 {\n    font-size: 24px;\n    line-height: 30px;\n}\n\n.ms-ft-40 {\n    font-size: 40px;\n    line-height: 48px;\n}\n\n.ms-ft-35 {\n    font-size: 35px;\n    line-height: 42.67px;\n}\n\n.ms-fw-600 {\n    font-weight: 600;\n}\n\n.ms-fw-400 {\n    font-weight: 400;\n}\n\n.ms-fw-700 {\n    font-weight: 700;\n}\n\n.ms-fw-800 {\n    font-weight: 800;\n}\n\n\n.ms-ft-primary {\n    color: #00863F;\n}\n\n.ms-ft-black {\n    color: #000;\n}\n\n.ms-ft-medblack {\n    color: #212121;\n}\n\n.ms-ft-fadedblack {\n    color: #4c4c4c\n}\n\n.ms-ft-grey {\n    color: #B5B5B5;\n}\n\n.ms-ft-darkgrey {\n    color: #54595F;\n}\n\n.ms-ft-mediumgrey {\n    color: #777;\n}\n\n.ms-ft-lightgrey {\n    color: #A3A3A3;\n}\n\n.mt-30 {\n    margin-top: 30px;\n}\n\n.mt-50 {\n    margin-top: 50px;\n}\n\n.mt-45 {\n    margin-top: 45px;\n}\n\n.mt-40 {\n    margin-top: 40px;\n}\n\n.mt-100 {\n    margin-top: 100px;\n}\n\n.mt-20 {\n    margin-top: 20px;\n}\n\n.pt-50 {\n    padding-top: 50px;\n}\n\n.pl-20 {\n    padding-left: 20px;\n}\n\n.btn-primary {\n    background-color: #00863F;\n}\n\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:target {\n    background-color: #00863F;\n}\n\n.btn-secondary {\n    background-color: #007BB6;\n    color: #fff;\n}\n\n.btn-secondary:hover,\n.btn-secondary:focus,\n.btn-secondary:target {\n    background-color: #007BB6;\n}\n\n.btn-info {\n    background-color: #666666;\n    color: #fff;\n}\n\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:target {\n    background-color: #666666;\n}\n\n.btn-light {\n    background-color: #ECECEE;\n    color: #BEBDBF;\n}\n\n.btn-light:hover,\n.btn-light:focus,\n.btn-light:target {\n    background-color: #ECECEE;\n}\n\n.btn {\n    font-family: 'Montserrat', sans-serif;\n    border-radius: 0px;\n    border: none;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n.ms-lh-20 {\n    line-height: 20px;\n}\n\n.badge.bg-primary {\n    background-color: #00863F24 !important;\n    font-family: Open Sans;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    letter-spacing: 0.25px;\n    text-align: left;\n    color: #00863F;\n    border-radius: 20px;\n}\n\n.full-height {\n    height: 100vh;\n}\n\n.form-check-input:checked {\n    background-color: #00863F;\n    border-color: #00863F;\n}\n\n.light-text {\n    color: #b3b3b3;\n}\n\n.dark-text-med {\n    color: #424242;\n}\n\n.fixed-height-30 {\n    min-height: 30px;\n}\n\n.light-text-med {\n    color: #808080;\n}\n\n.navbar {\n    float: unset !important;\n}\n\n.btn.disabled,\n.btn:disabled {\n    background-color: #808080;\n    color: #000;\n    pointer-events: none;\n}\n\n::-ms-reveal {\n    display: none;\n}\n\n.error-message {\n    position: absolute;\n    bottom: -20px;\n    color: red;\n    font-size: 12px;\n    margin-bottom: 0;\n}\n\n.text-danger {\n    color: #e25425 !important;\n}\n\n.spinner-border{\n    color: #00863F;\n}\n\n.spinner-border-popup{\n    color: #eaf1ed;\n}\n\n.section-overlay {\n    z-index: 9999;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.2);\n    opacity: 0.8;\n}\n\n.section-loader.loading {\n    position: fixed;\n    margin: auto;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 40px;\n    height: 40px;\n    z-index: 10000;\n    background: transparent;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
